import { createAction, createReducer } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from '@store/types';
import type { HeaderState } from './types';

// Re-export types for consumers
export type { HeaderState } from './types';

const initState: HeaderState = {
  mainMenuScrollX: 0,
  levelSubScreenScrollX: 0,
  nowSubScreenScrollX: 0,
  machinesSettingsScrollX: 0,
  hasInitialScrolled: false,
  currentScreenTitle: null,
};

export const selectMainMenuScrollX = (state: RootState) => state.header.mainMenuScrollX;
export const selectedLevelSubScreenScrollX = (state: RootState) => state.header.levelSubScreenScrollX;
export const selectedNowSubScreenScrollX = (state: RootState) => state.header.nowSubScreenScrollX;
export const selectedMachinesSettingsScrollX = (state: RootState) => state.header.machinesSettingsScrollX;
export const selectCurrentScreenTitle = (state: RootState) => state.header.currentScreenTitle;
export const selectHasInitialScrolled = (state: RootState) => state.header.hasInitialScrolled;

export const setMainMenuScrollXAction = createAction<number>('setMainMenuScrollXAction');
export const setLevelSubScreenScrollXAction = createAction<number>('setLevelSubScreenScrollXAction');
export const setNowSubScreenScrollXAction = createAction<number>('setNowSubScreenScrollXAction');
export const setHasInitialScrolledAction = createAction<boolean>('setHasInitialScrolledAction');
export const setMachinesSettingsScrollXAction = createAction<number>('setMachinesSettingsScrollXAction');
export const setCurrentScreenTitleAction = createAction<string | null>('setCurrentScreenTitleAction');

export const setMainMenuScrollX = (x: number) => (dispatch: AppDispatch) => {
  dispatch(setMainMenuScrollXAction(x));
};
export const setLevelSubScreenScrollX = (x: number) => (dispatch: AppDispatch) => {
  dispatch(setLevelSubScreenScrollXAction(x));
};
export const setNowSubScreenScrollX = (x: number) => (dispatch: AppDispatch) => {
  dispatch(setNowSubScreenScrollXAction(x));
};
export const setHasInitialScrolled = (state: boolean) => (dispatch: AppDispatch) => {
  dispatch(setHasInitialScrolledAction(state));
};
export const setMachinesSettingsScrollX = (state: number) => (dispatch: AppDispatch) => {
  dispatch(setMachinesSettingsScrollXAction(state));
};
export const setCurrentScreenTitle = (title: string | null) => (dispatch: AppDispatch) => {
  dispatch(setCurrentScreenTitleAction(title));
};

export default createReducer<HeaderState>(initState, {
  [setMainMenuScrollXAction.type]: (state, action) => {
    return { ...state, mainMenuScrollX: action.payload };
  },
  [setLevelSubScreenScrollXAction.type]: (state, action) => {
    return { ...state, levelSubScreenScrollX: action.payload };
  },
  [setNowSubScreenScrollXAction.type]: (state, action) => {
    return { ...state, nowSubScreenScrollX: action.payload };
  },
  [setMachinesSettingsScrollXAction.type]: (state, action) => {
    return { ...state, machinesSettingsScrollX: action.payload };
  },
  [setHasInitialScrolledAction.type]: (state, action) => {
    return { ...state, hasInitialScrolled: action.payload };
  },
  [setCurrentScreenTitleAction.type]: (state, action) => {
    return { ...state, currentScreenTitle: action.payload };
  },
});
